module.exports = __webpack_public_path__ + "img/help.89ed381b.svg";